import { s as g, c as u, a as o, e as n, f as d } from "./vendor-DxSylgwR.js";
var R = /* @__PURE__ */ ((r) => (r.UNKNOWN = "UNKNOWN", r.NETWORK_ERROR = "NETWORK_ERROR", r.VALIDATION_ERROR = "VALIDATION_ERROR", r.API_ERROR = "API_ERROR", r.STORAGE_ERROR = "STORAGE_ERROR", r.INVALID_STATE = "INVALID_STATE", r.RATE_LIMIT = "RATE_LIMIT", r.UNAUTHORIZED = "UNAUTHORIZED", r.ITEM_NOT_AVAILABLE = "ITEM_NOT_AVAILABLE", r.COUPON_INVALID = "COUPON_INVALID", r.PAYMENT_FAILED = "PAYMENT_FAILED", r.UNKNOWN_ERROR = "UNKNOWN_ERROR", r.REQUEST_TIMEOUT = "REQUEST_TIMEOUT", r.INVALID_OPERATION = "INVALID_OPERATION", r.CART_NOT_FOUND = "CART_NOT_FOUND", r.CART_ALREADY_COMPLETED = "SP:CartAlreadyCompleted", r))(R || {});
class m extends Error {
  constructor(a, i, t, e, s, I = !1) {
    super(a), this.code = i, this.status = t, this.details = e, this.data = s, this.retryable = I, this.name = "CartError", this.data = s, this.code = i, this.status = t, this.details = e, this.retryable = I, this.message = a, Object.setPrototypeOf(this, m.prototype);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      code: this.code,
      status: this.status,
      details: this.details,
      retryable: this.retryable
    };
  }
}
class p extends m {
  constructor(a = "API_ERROR", i, t, e, s = {}, I) {
    super(
      i,
      "API_ERROR",
      t,
      e,
      s,
      t >= 500
    ), this.code = a, this.message = i, this.status = t, this.details = e, this.data = s, this.config = I, this.name = "APIError", this.data = s, this.config = I, Object.setPrototypeOf(this, p.prototype);
  }
}
class E extends m {
  constructor(a, i) {
    super(a, "INVALID_STATE", 400, i, !1), this.name = "CartStateError", Object.setPrototypeOf(this, E.prototype);
  }
}
class l extends m {
  constructor(a = "Network error occurred", i) {
    super(a, "NETWORK_ERROR", void 0, i, !0), this.name = "NetworkError";
  }
}
var A = /* @__PURE__ */ ((r) => (r.MADA = "mada", r.VISA = "visa", r.CASH = "cash", r.APPLE_PAY = "applepay", r.TAMARA = "tamara", r.TABBY = "tabby", r.BANK_TRANSFER = "banktransfer", r))(A || {}), T = /* @__PURE__ */ ((r) => (r.REKAZPAY = "rekaz-pay", r.MOYASAR = "moyasar", r))(T || {}), c = /* @__PURE__ */ ((r) => (r.CART_CREATED = "cartCreated", r.CART_UPDATED = "cartUpdated", r.CART_COMPLETED = "cartCompleted", r.ITEMS_ADDED = "itemsAdded", r.ITEMS_REMOVED = "itemsRemoved", r.ITEMS_UPDATED = "itemsUpdated", r.COUPON_UPDATED = "couponUpdated", r.CUSTOMER_UPDATED = "customerUpdated", r.CART_SUBMITTED = "cartSubmitted", r.NOTES_UPDATED = "notesUpdated", r.CUSTOM_FIELDS_UPDATED = "customFieldsUpdated", r.ITEMS_ADDING = "itemsAdding", r.ITEMS_REMOVING = "itemsRemoving", r.ITEMS_UPDATING = "itemsUpdating", r.COUPON_UPDATING = "couponUpdating", r.CUSTOMER_UPDATING = "customerUpdating", r.CUSTOM_FIELDS_UPDATING = "customFieldsUpdating", r.ERROR = "cartError", r.ITEMS_ADD_FAILED = "itemsAddFailed", r.ITEMS_REMOVE_FAILED = "itemsRemoveFailed", r.COUPON_UPDATE_FAILED = "couponUpdateFailed", r.CUSTOMER_UPDATE_FAILED = "customerUpdateFailed", r.CUSTOM_FIELDS_UPDATE_FAILED = "customFieldsUpdateFailed", r))(c || {});
const h = 5, D = (r, a, i) => g({
  actors: {
    loadCart: d(async ({ input: t }) => {
      const e = t?.cartId || await a.get("cartId");
      if (!e) {
        const s = await r.createCart();
        return await a.set("cartId", s.id), s;
      }
      try {
        return await r.getCart(e);
      } catch (s) {
        if (s.status === 404) {
          const I = await r.createCart();
          return await a.set("cartId", I.id), I;
        }
        throw i.normalizeError(s, {
          cartId: e,
          operation: "LOAD_CART"
        });
      }
    }),
    refetchCart: d(async ({ input: t }) => await r.refetchCart(t.cartId)),
    validateCart: d(async ({ input: t }) => await r.validateCart(t.cart.id)),
    addItems: d(async ({ input: t }) => {
      try {
        return await r.addItems(
          t.cartId,
          t.items,
          t.singleItem
        );
      } catch (e) {
        throw i.normalizeError(e, {
          cartId: t.cartId,
          operation: "ADD_ITEMS"
        });
      }
    }),
    removeItems: d(
      async ({ input: t }) => {
        try {
          return await r.removeItems(t.cartId, t.itemIds);
        } catch (e) {
          throw i.normalizeError(e, {
            cartId: t.cartId,
            operation: "REMOVE_ITEMS"
          });
        }
      }
    ),
    updateItems: d(async ({ input: t }) => {
      try {
        return await r.updateItems(t.cartId, t.items);
      } catch (e) {
        throw i.normalizeError(e, {
          cartId: t.cartId,
          operation: "UPDATE_ITEMS"
        });
      }
    }),
    updateCustomer: d(async ({ input: t }) => {
      try {
        return await r.updateCustomerIdentity(
          t.cartId,
          t.customer
        );
      } catch (e) {
        throw i.normalizeError(e, {
          cartId: t.cartId,
          operation: "UPDATE_CUSTOMER"
        });
      }
    }),
    updateCoupon: d(
      async ({ input: t }) => {
        try {
          return await r.updateCoupon(
            t.cartId,
            t.couponCode
          );
        } catch (e) {
          throw i.normalizeError(e, {
            cartId: t.cartId,
            operation: "UPDATE_COUPON"
          });
        }
      }
    ),
    submitOrder: d(async ({ input: t }) => {
      try {
        return t.paymentMethod === A.CASH || t.paymentMethod === A.BANK_TRANSFER ? await r.submitCart(
          t.cartId,
          t.paymentMethod
        ) : await r.getCart(t.cartId);
      } catch (e) {
        throw i.normalizeError(e, {
          cartId: t.cartId,
          operation: "SUBMIT_ORDER"
        });
      }
    })
  },
  actions: {
    clearStorage: () => a.remove("cartId"),
    incrementRetries: o({
      errorRetries: ({ context: t }) => t.errorRetries + 1
    }),
    resetRetries: o({
      errorRetries: 0
    }),
    emitCartUpdated: n(({ context: t }) => ({
      type: c.CART_UPDATED,
      cart: t.cart
    })),
    emitItemAdded: n(({ context: t }) => ({
      type: c.ITEMS_ADDED,
      cart: t.cart
    })),
    emitItemRemoved: n(({ context: t }) => ({
      type: c.ITEMS_REMOVED,
      cart: t.cart
    })),
    emitItemUpdated: n(({ context: t }) => ({
      type: c.ITEMS_UPDATED,
      cart: t.cart
    })),
    emitCustomerUpdated: n(({ context: t }) => ({
      type: c.CUSTOMER_UPDATED,
      cart: t.cart
    })),
    emitCouponUpdated: n(({ context: t }) => ({
      type: c.COUPON_UPDATED,
      cart: t.cart
    })),
    emitCartCreated: n(({ context: t }) => ({
      type: c.CART_CREATED,
      cart: t.cart
    })),
    emitCartCompleted: n(() => ({
      type: c.CART_COMPLETED
    })),
    emitError: n(({ context: t }) => ({
      type: c.ERROR,
      error: t.error
    }))
  },
  guards: {
    canRetry: ({ context: t }) => t.errorRetries < h,
    hasCart: ({ context: t }) => t.cart !== null,
    isCartEmpty: ({ context: t }) => !t.cart?.cartItems || t.cart.cartItems.length === 0,
    isCartValid: ({ context: t }) => {
      try {
        return !0;
      } catch (e) {
        return console.error("Cart validation failed:", e), !1;
      }
    },
    isForbidden: ({ context: t }) => t.error?.code == R.API_ERROR
  }
}).createMachine({
  id: "cart",
  initial: "initializing",
  context: ({ input: t }) => ({
    cart: null,
    cartId: t?.cartId || null,
    error: void 0,
    errorRetries: 0,
    pendingPaymentMethod: null
  }),
  states: {
    initializing: {
      tags: ["loading"],
      invoke: {
        src: "loadCart",
        input: ({ context: t }) => ({ cartId: t.cartId || void 0 }),
        onDone: {
          target: "idle",
          actions: [
            o({
              cart: ({ event: t }) => t.output,
              cartId: ({ event: t }) => t.output.id
            }),
            { type: "emitCartCreated" }
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error
          })
        }
      }
    },
    validating: {
      tags: ["loading"],
      invoke: {
        src: "validateCart",
        input: ({ context: t }) => ({ cart: t.cart }),
        onDone: {
          target: "submittingOrder",
          actions: [
            o({
              cart: ({ event: t }) => t.output
            }),
            "resetRetries"
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error,
            pendingPaymentMethod: null
          })
        }
      }
    },
    refetchingCart: {
      tags: ["loading"],
      invoke: {
        src: "refetchCart",
        input: ({ context: t }) => {
          if (!t.cartId)
            throw new E("Cannot refetch cart without a cartId");
          return {
            cartId: t.cartId
          };
        },
        onDone: {
          target: "idle",
          actions: [
            o({
              cart: ({ event: t }) => t.output
            }),
            "emitCartUpdated"
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error
          })
        }
      }
    },
    idle: {
      tags: ["idle"],
      on: {
        ADD_ITEMS: {
          target: "addingItems"
        },
        REMOVE_ITEMS: {
          target: "removingItems"
        },
        UPDATE_ITEMS: {
          target: "updatingItems"
        },
        UPDATE_CUSTOMER: "updatingCustomer",
        UPDATE_COUPON: "updatingCoupon",
        SUBMIT_ORDER: {
          guard: "isCartValid",
          target: "validating",
          actions: o({
            pendingPaymentMethod: ({ event: t }) => t.paymentMethod
          })
        },
        REFETCH_CART: "refetchingCart"
      }
    },
    addingItems: {
      tags: ["processing"],
      invoke: {
        src: "addItems",
        input: ({ context: t, event: e }) => {
          if (e.type !== "ADD_ITEMS")
            throw new E(
              "Invalid event type: Expected ADD_ITEMS, got " + e.type
            );
          return {
            cartId: t.cartId,
            items: e.items,
            singleItem: e.singleItem ?? !1
          };
        },
        onDone: {
          target: "idle",
          actions: [
            o({
              cart: ({ event: t }) => t.output
            }),
            "emitItemAdded",
            "emitCartUpdated"
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error
          })
        }
      }
    },
    removingItems: {
      tags: ["processing"],
      invoke: {
        src: "removeItems",
        input: ({ context: t, event: e }) => {
          if (e.type !== "REMOVE_ITEMS")
            throw new E(
              "Invalid event type: Expected REMOVE_ITEMS, got " + e.type
            );
          return {
            cartId: t.cartId,
            itemIds: e.itemIds
          };
        },
        onDone: {
          target: "idle",
          actions: [
            o({
              cart: ({ event: t }) => t.output
            }),
            "emitCartUpdated",
            "emitItemRemoved"
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error
          })
        }
      }
    },
    updatingItems: {
      tags: ["processing"],
      invoke: {
        src: "updateItems",
        input: ({ context: t, event: e }) => {
          if (e.type !== "UPDATE_ITEMS")
            throw new E(
              "Invalid event type: Expected UPDATE_ITEMS, got " + e.type
            );
          return {
            cartId: t.cartId,
            items: e.items
          };
        },
        onDone: {
          target: "idle",
          actions: [
            o({
              cart: ({ event: t }) => t.output
            }),
            "emitCartUpdated",
            "emitItemUpdated"
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error
          })
        }
      }
    },
    updatingCustomer: {
      tags: ["processing"],
      invoke: {
        src: "updateCustomer",
        input: ({ context: t, event: e }) => {
          if (e.type !== "UPDATE_CUSTOMER")
            throw new E(
              "Invalid event type: Expected UPDATE_CUSTOMER, got " + e.type
            );
          return {
            cartId: t.cartId,
            customer: e.customer
          };
        },
        onDone: {
          target: "idle",
          actions: [
            o({
              cart: ({ event: t }) => t.output
            }),
            "emitCartUpdated",
            "emitCustomerUpdated"
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error
          })
        }
      }
    },
    updatingCoupon: {
      tags: ["processing"],
      invoke: {
        src: "updateCoupon",
        input: ({ context: t, event: e }) => {
          if (e.type !== "UPDATE_COUPON")
            throw new E(
              "Invalid event type: Expected UPDATE_COUPON, got " + e.type
            );
          return {
            cartId: t.cartId,
            couponCode: e.code
          };
        },
        onDone: {
          target: "idle",
          actions: [
            o({
              cart: ({ event: t }) => t.output
            }),
            "emitCartUpdated",
            "emitCouponUpdated"
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error
          })
        }
      }
    },
    submittingOrder: {
      tags: ["processing"],
      invoke: {
        src: "submitOrder",
        input: ({ context: t }) => ({
          cartId: t.cartId,
          paymentMethod: t.pendingPaymentMethod
        }),
        onDone: {
          target: "completed",
          actions: [
            o({
              cart: ({ event: t }) => t.output,
              pendingPaymentMethod: null
            }),
            "clearStorage",
            "emitCartCompleted"
          ]
        },
        onError: {
          target: "error",
          actions: o({
            error: ({ event: t }) => t.error,
            pendingPaymentMethod: null
          })
        }
      }
    },
    error: {
      tags: ["error"],
      entry: [{ type: "incrementRetries" }, { type: "emitError" }],
      on: {
        RETRY: [
          {
            guard: "canRetry",
            target: "validating"
          },
          {
            target: "terminated",
            actions: ["clearStorage"]
          }
        ],
        RESET: {
          target: "initializing",
          actions: ["clearStorage", "resetRetries"]
        }
      },
      always: {
        // TODO: no no
        target: "idle"
      }
    },
    completed: {
      type: "final"
    },
    terminated: {
      type: "final"
    }
  }
});
class O {
  machine = null;
  actor = null;
  /**
   * Creates a new CartStateMachine instance.
   *
   * @param queryService - Service for cart-related API operations
   * @param storage - Service for persisting cart data between sessions
   * @param errorHandler - Service for normalizing and handling errors
   */
  constructor(a, i, t) {
    this.machine = D(a, i, t);
  }
  /**
   * Returns the underlying machine instance.
   *
   * @returns The XState machine instance
   * @throws Error if the machine is not initialized
   */
  getInstance() {
    if (!this.machine)
      throw new Error("Machine not initialized");
    return this.machine;
  }
  /**
   * Creates an actor instance if one doesn't exist.
   *
   * @returns The XState actor instance
   * @throws Error if the machine is not initialized
   */
  createActor(a = {}) {
    if (!this.machine)
      throw new Error("Machine not initialized");
    return this.actor || (this.actor = u(this.machine, { input: a })), this.actor;
  }
  /**
   * Gets the actor instance, starting it if necessary.
   *
   * @returns The active XState actor instance
   */
  getActor() {
    const a = this.createActor();
    return a.getSnapshot().status !== "active" && a.start(), a;
  }
  /**
   * Gets the current state snapshot of the actor.
   *
   * @returns The current state snapshot
   */
  getState() {
    return this.getActor().getSnapshot();
  }
  /**
   * Gets the current context of the state machine.
   *
   * @returns The current context with cart data
   */
  getContext() {
    return this.getState().context;
  }
  /**
   * Sends an event to the state machine.
   *
   * @param event - The event to send to the state machine
   */
  send(a) {
    this.getActor().send(a);
  }
  /**
   * Checks if the state machine is in a loading state.
   *
   * @returns True if the machine is in a loading state
   */
  isLoading() {
    return this.getState().tags.has("loading") || this.getState().tags.has("processing");
  }
  /**
   * Checks if the state machine is in an error state.
   *
   * @returns True if the machine is in an error state
   */
  isError() {
    return this.getState().tags.has("error");
  }
  /**
   * Gets the current error if the machine is in an error state.
   *
   * @returns The current error or undefined
   */
  getError() {
    return this.getContext().error;
  }
  /**
   * Sends a retry event to recover from an error state.
   */
  retry() {
    this.send({ type: "RETRY" });
  }
  /**
   * Stops the actor if it's running.
   */
  stop() {
    this.actor && this.actor.stop();
  }
}
export {
  p as A,
  m as C,
  l as N,
  A as P,
  R as a,
  O as b,
  c,
  T as d
};
//# sourceMappingURL=cart-machine-DaahVifl.js.map
